import { DataProvider } from "../helpers"

import { OpFile } from "../models/core"
import { Enums } from "../models/common"
import { ColumnInfo } from "../models/custom"
import { OpReport } from "../models/dw"

export class DataProviderReport {

    // Ctor

    constructor(private dataProvider: DataProvider) { }

    // Ctor End


    // Public Methods
    
    public deleteReport = (opObj: OpReport): JQueryPromise<OpReport> => {
        return this.dataProvider
            .sendRequestWithSession('OpxDeleteReport', { ToBeDeleted: opObj.toJSON() }, null)
            .then((data: any) => {
                const result: OpReport = new OpReport(data)

                OpReport.loadNavigationProperties(this.dataProvider, [result])

                return result
            })
    }


    public generateReport = (opObj: OpReport): JQueryPromise<any> => {
        return this.dataProvider.sendRequestWithSession('OpxGenerateReport', { report: opObj.toJSON() }, 'OpxGenerateReportResult')
    }

    public getReport = (id: number): JQueryPromise<OpReport> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetReport', { idReport: id }, 'OpxGetReportResult')
            .then(data => {
                var result: OpReport = new OpReport(data)
                OpReport.loadNavigationProperties(this.dataProvider, [result])
                return result
            })
    }


    public getReportFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
        return this.dataProvider.sendFilterRequestWithSession<OpReport>(columns, pageNbr, pageSize, customWhereClause, Enums.ReferenceType.IdReport, 'OpxReportFilter', 'OpxReportFilterResult')
    }
 
    public getGeneratedReport = (id: number, fileName: string) => {
        return this.dataProvider
            .sendRequestWithSession('OpxDownloadGeneratedReport', { IdReport: id, FileName: fileName }, 'OpxDownloadGeneratedReportResult')
            .then((data: any) => {
                return new OpFile(data)
            })
    }

    public saveReport = (opObj: OpReport): JQueryPromise<OpReport> => {
        return this.dataProvider
            .sendRequestWithSession('OpxSaveReport', { ToBeSaved: opObj.toJSON() }, 'OpxSaveReportResult')
            .then((data: any) => {
                const result: OpReport = new OpReport(data)

                OpReport.loadNavigationProperties(this.dataProvider, [result])

                return result
            })
    }

    // Public Methods End
}